import { axios, exportAction } from '@/libs/api.request';
import { Response } from '@/types/request.d';
import i18n from '@/locales';

interface PageParams {
    page?: number;
    page_size?: number;
    channel?: Chat.channel | string
    link_name?: string
}

export interface SplitLinkItem {
    channel: Chat.channel;
    link_name: string;
    link: string;
    associate_account: string;
    status: '0' | '1';
    created_time: string;
    nickname: string;
    split_type: 'group' | 'phone';
    split_status: '0' | '1'; // 0 无可分配的有效账号，1 正常
    id:string;
}

interface SplitLinkRes {
    list: SplitLinkItem[]
    page: number;
    page_size: number;
}

/**
 * 获取分流链接列表
 * @param params
 */
export const getSplitLinkList = (params: PageParams) => axios.request<Response<SplitLinkRes>>({
    url: '/chat/split-link/get-split-link-list',
    method: 'get',
    params,
});

/**
 * 获取分流链接总数
 */
export const getSplitLinkCount = (params: PageParams) => axios.request<Response<{ total: string }>>({
    url: '/chat/split-link/get-split-link-count',
    method: 'get',
    params,
});

interface SplitLinkInfo {
    id?: string;
    project_id?: string;
    sys_user_id?: string;
    channel: Chat.channel;
    link_name: string;
    link?: string;
    status: '0' | '1';
    split_type: 'group' | 'phone';
    split_method_switch: '0' | '1'; // 分流规则 0-随机 1-时间段
    split_time_configure?: any; // 分流时间段设置
    associate_account: string; // 关联账号信息
    prologue: string; // 默认开场白
    link_params: string; // 分流参数
}

export const getSplitLinkInfo = (params: { id: string }) => axios.request<Response<SplitLinkInfo>>({
    url: '/chat/split-link/get-split-link-info',
    method: 'get',
    params,
});

/**
 * 添加/编辑分流链接
 * @param data
 */
export const updateSplitLink = (data: SplitLinkInfo) => axios.request<Response<{ id: string }>>({
    url: '/chat/split-link/update-split-link',
    method: 'post',
    data,
});

/**
 * 删除分流链接
 * @param data
 */
export const delSplitLink = (data: { id: string }) => axios.request<Response<any>>({
    url: '/chat/split-link/del-split-link',
    method: 'post',
    data,
});

interface SplitLinkStatusInfo {
    id: string;
    status: '0' | '1';
}

export const updateSplitLinkStatus = (data: SplitLinkStatusInfo) => axios.request<Response<any>>({
    url: '/chat/split-link/update-split-link-status',
    method: 'post',
    data,
});
export interface SplitLinkAnalysisTrendRes {
    access_date: string;
    count: string;
}
export interface SplitLinkAnalysisOverviewRes {
    click_count: string;
}
export interface SplitLinkAnalysisInfo {
    link_id: string;
    start_date_hour: string;
    end_date_hour: string;
    page?: number;
    page_size?: number;
    lang?: string;
}

// 获取分流链接洞察总数
export const splitLinkAnalysisOverview = (params: SplitLinkAnalysisInfo) => axios.request<Response<any>>({
    url: '/chat/split-link/split-link-analysis-overview',
    method: 'get',
    params,
});

// 获取分流链接洞察趋势
export const splitLinkAnalysisTrend = (params: SplitLinkAnalysisInfo) => axios.request<Response<any>>({
    url: '/chat/split-link/split-link-analysis-trend',
    method: 'get',
    params,
});

// 获取分流链接洞察每日明细
export const splitLinkAnalysisDistributed = (params: SplitLinkAnalysisInfo) => axios.request<Response<any>>({
    url: '/chat/split-link/split-link-analysis-distributed',
    method: 'get',
    params,
});

// 获取分流链接洞察每日明细总数
export const splitLinkAnalysisDistributedCount = (params: SplitLinkAnalysisInfo) => axios.request<Response<any>>({
    url: '/chat/split-link/split-link-analysis-distributed-count',
    method: 'get',
    params,
});

// 导出分流链接洞察每日明细
export const exportAnalysisDistributed = (params: SplitLinkAnalysisInfo) => {
    params.lang = ['zh-CN', 'zh-TW'].includes(i18n.locale) ? 'zh-CN' : (i18n.locale || 'zh-CN');
    return exportAction({
        url: 'chat/split-link/export-analysis-distributed',
        method: 'get',
        // @ts-ignore
        params,
    });
};
